/** Frame look shared by playtest cards and panels. */
export const FRAME_BORDER = '1px solid rgba(128, 128, 128, 0.4)';
export const FRAME_RADIUS = 4;
/** Border for a control drawn in the text colour, such as a tier option. */
export const CURRENT_COLOR_BORDER = '1px solid currentColor';
